exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-container[data-v-0023e65e] {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.image-container .after[data-v-0023e65e] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n  color: #fff;\n  background: rgba(0, 0, 0, .6);\n}\n.image-container:hover .after[data-v-0023e65e] {\n  display: block;\n  background: rgba(0, 0, 0, .6);\n}\n", ""]);

// exports
